<template>
  <div>
    <div class="margin-top margin-left">
      <el-button size="mini" @click="getTemplateList()">查询</el-button>
      <el-button size="mini" @click="add()">新增模版</el-button>
      <el-button size="mini" @click="typeListDialog()">设置模版类别</el-button>
    </div>
    <el-descriptions
      class="margin-top margin-left"
      :column="2"
      size="mini"
      border
    >
      <el-descriptions-item label="模版类别">
        <el-select
          v-model="data.type"
          placeholder="请选择"
          clearable
          size="mini"
        >
          <el-option
            v-for="item in typeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="创建操作员">
        <el-input
          v-model="data.adminName"
          size="mini"
          placeholder="请输入"
          style="width: 250px"
        />
      </el-descriptions-item>
      <el-descriptions-item label="模版名称">
        <el-input
          v-model="data.name"
          size="mini"
          placeholder="请输入"
          style="width: 250px"
        />
      </el-descriptions-item>
      <el-descriptions-item label=""></el-descriptions-item>
    </el-descriptions>
    <el-table
      class="margin-top margin-left"
      max-height="750px"
      :data="listData"
      border
      v-loading="loading"
    >
      <el-table-column label="模版类别" prop="type_name" />
      <el-table-column label="模版名称" prop="name" />
      <el-table-column label="创建时间" prop="create_at" />
      <el-table-column label="操作员" prop="admin_name" />
      <el-table-column label="操作">
        <template slot-scope="data">
          <el-link @click="edit(data.row.id)"> 修改 </el-link>
          <el-link @click="del(data.row.id)"> 删除 </el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="float: right"
      background
      layout="sizes, prev, pager, next"
      :current-page.sync="data.page"
      :total="totalCount"
      :page-sizes="[10, 20, 50, 100]"
      :page-size.sync="data.pageSize"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    <sms-template-view
      :dialog.sync="templateViewer.dialog"
      :id="templateViewer.id"
      :mode="templateViewer.mode"
      :type-list="typeList"
      @close="closeViewer()"
      @save="getTemplateList()"
    />
    <el-dialog
      title="设置模版类别"
      :visible="dialog"
      width="60%"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="模版类别">
          <el-input v-model="form.name" size="mini" style="width: 80%" />
          <el-button size="mini" @click="saveType()">新增模版类别</el-button>
        </el-form-item>
      </el-form>
      <el-table
        class="margin-top margin-left"
        max-height="750px"
        :data="typeList"
        border
        v-loading="loading"
      >
        <el-table-column label="模版类别" prop="name" />
        <el-table-column label="操作">
          <template slot-scope="data">
            <el-button size="mini" type="text" @click="delType(data.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import SmsTemplateView from "@/components/Admin/Butler/SmsTemplateView";
export default {
  name: "SmsTemplate",
  components: { SmsTemplateView },
  data() {
    return {
      data: {
        type: "",
        adminName: "",
        name: "",
        page: 1,
        pageSize: 10,
      },
      typeList: [],
      listData: [],
      templateViewer: {
        id: 0,
        mode: "add",
        dialog: false,
      },
      loading: false,
      totalCount: 0,
      dialog: false,
      form: {
        name: "",
      },
    };
  },
  mounted() {
    this.getTemplateTypeList();
    this.getTemplateList();
  },
  methods: {
    getTemplateTypeList() {
      this.$myhttp
        .post(
          "admin/SmsTemplate/getTemplateTypeList",
          {},
          {
            "Content-Type": "application/x-www-form-urlencoded",
          }
        )
        .then((res) => {
          // 异步执行成功后
          this.typeList = res.data.data;
        });
    },
    getTemplateList() {
      this.$myhttp
        .post("admin/SmsTemplate/getTemplateList", this.data, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((res) => {
          // 异步执行成功后
          this.listData = res.data.data;
          this.totalCount = res.data.totalCount;
        });
    },
    edit(id) {
      this.templateViewer = {
        id: id,
        mode: "edit",
        dialog: true,
      };
    },
    add() {
      this.templateViewer = {
        id: 0,
        mode: "add",
        dialog: true,
      };
    },
    closeViewer() {
      this.templateViewer.dialog = false;
    },
    del(id) {
      this.loading = true;
      this.$myhttp
        .post(
          "admin/SmsTemplate/deleteTemplate",
          { id },
          {
            "Content-Type": "application/x-www-form-urlencoded",
          }
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success("成功");
            this.loading = false;
            this.getTemplateList();
          } else {
            this.$message.error(res.data.msg);
            this.loading = false;
          }
        });
    },
    handleSizeChange() {
      this.getTemplateList();
    },
    handleCurrentChange() {
      this.getTemplateList();
    },
    typeListDialog() {
      this.dialog = true;
    },
    handleClose() {
      this.dialog = false;
    },
    saveType() {
      this.$myhttp
        .post("admin/SmsTemplate/saveTemplateType", this.form, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success("成功");
            this.getTemplateTypeList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    delType(id) {
      this.$myhttp
        .post(
          "admin/SmsTemplate/delTemplateType",
          { id },
          {
            "Content-Type": "application/x-www-form-urlencoded",
          }
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success("成功");
            this.getTemplateTypeList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
  },
};
</script>

<style>
.margin-top {
  margin-top: 10px;
}
.margin-left {
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/Admin/Butler/SmsTemplate.vue